<template>
  <div>
    <button class="btn btn-primary btn-sm"
        data-toggle="tooltip" 
        data-placement="top" 
        title="New"
        @click="fnShowModal()">New
    </button>

    <b-modal ref="modal" hide-footer title="Forms - new">
        <div class="d-block">
        <form v-on:submit.prevent="createNew">
            <div class="form-group">
                <label for="form_title">Form title</label>
                <input type="text" 
                class="form-control" 
                id="form_title" 
                placeholder="Form title"
                v-model="form_title">
                <div class="invalid-feedback" v-if="errors.form_title">{{ errors.form_title[0] }}</div>
            </div>
            <div class="form-group">
                <label for="provider">Provider</label>
                <input type="text" 
                class="form-control" 
                id="provider" 
                placeholder="Provider"
                v-model="provider">
                <div class="invalid-feedback" v-if="errors.provider">{{ errors.provider[0] }}</div>
            </div>
            <div class="form-group">
                <label for="other1">Other title1</label>
                <input type="text" 
                class="form-control" 
                id="other1" 
                placeholder="Other title1"
                v-model="other1">
            </div>
            <div class="form-group">
                <label for="other2">Other title2</label>
                <input type="text" 
                class="form-control" 
                id="other2" 
                placeholder="Other title2"
                v-model="other2">
            </div>
            <div class="form-group">
                <label for="other2">Form</label>
                <div>
                <input type="file" 
                    class="" 
                    placeholder="Other title2"
                    v-on:change="onChange">
                </div>
            </div>

            <hr>
            <div class="text-right">
                <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
                <button type="submit" class="btn btn-primary btn-sm">Save</button>
            </div>
        </form>
        </div>
    </b-modal>
  </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as formDownloadService from '../../services/formDownload.service';
    export default {
        name:"ModalFormsDownloadNew",
        components: {
            
        },
        data(){
            return{
                errors:{},
                form_title:'',
                provider:'',
                other1:'',
                other2:'',
                file:'',
            }
        },
        methods:{
            ...mapActions([
                'fetchFormDownloadAll'
            ]),
            onChange(e) {
                this.file = e.target.files[0];
            },
            fnShowModal(){
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            createNew:async function(){
                let formData = new FormData();
                formData.append('form_title', this.form_title);
                formData.append('provider', this.provider);
                formData.append('other1', this.other1);
                formData.append('other2', this.other2);
                formData.append('file', this.file);
            try{
                const response = await formDownloadService.add(formData);

                this.hideModal();
                this.fetchFormDownloadAll()

                messageService.fnSweetAlertSuccessToast('Form - new', 'added successfully');

                this.name = '';

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Form - new', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Form - new', 'Something wrong');
                        break;
                    }
                }
            },
        }
    }
</script>